import * as Yup from "yup";

export function initialValues(item) {
  return {
    title: item?.title || "",
    type: item?.type || "Riesgo",
    description: item?.description || "",
    aspect: item?.aspect || null,
    condition: item?.condition || "Normal",
    obligation: item?.obligation || null,
    compliance: item?.compliance || "Cumple",
    probability: item?.probability || null,
    severity: item?.severity || null,
    controls: item?.controls || "",
    action: item?.action || "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    title: Yup.string().required(t("required_field")),
    aspect: Yup.string().required(t("required_field")),
    probability: Yup.number().min(1).max(5).required(t("required_field")),
    severity: Yup.number().min(1).max(5).required(t("required_field")),
  });
}
